import { gql } from '@apollo/client';
import { renderFragments, contactInfoFragment } from '../../lib/fragments';

export const chipContactInfoForVerifiedRescueQuery = gql`
  query chipContactInfoForVerifiedRescue($id: ID!) {
    chipContactInfoForVerifiedRescue(id: $id) {
      serialNumber
      latestContactHistoryEntry {
        contactInfo {
          ...contactInfo
        }
      }
    }
  }
  ${renderFragments(contactInfoFragment)}
`;
